module.exports = __webpack_public_path__ + "img/logo-gray.639e7d5b.png";